export default __webpack_public_path__ + "static/hero-right-80b912974a2096e31a104212d588d860.svg";